export type NavItem = { label: string; to: string };

const env = import.meta.env;

export const siteConfig = {
  siteName: "Gooobus",
  domain: (env.VITE_SITE_DOMAIN as string) || "https://gooobus.com",
  contactEmail: "1900nails@gmail.com",
  description:
    "CRM Business Blog: honest reviews, buyer's guides, and comparisons for modern CRM software.",
  author: "Gooobus Editorial",
  defaultOgImage:
    "https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200&auto=format&fm=webp&q=70",
  fallbackImage:
    "https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200&auto=format&fm=webp&q=70",
  adsensePublisherId:
    (env.VITE_ADSENSE_PUBLISHER_ID as string) || "ca-pub-XXXXXXXXXXXXXXXX",
  adsensePublisherId2: (env.VITE_ADSENSE_PUBLISHER_ID_2 as string) || "",
  adSlots: {
    homeInFeed: (env.VITE_ADSENSE_SLOT_HOME_INFEED as string) || "",
    postTopNative: (env.VITE_ADSENSE_SLOT_POST_TOP_NATIVE as string) || "",
    postMultiplex: (env.VITE_ADSENSE_SLOT_POST_MULTIPLEX as string) || "",
    postInArticle1: (env.VITE_ADSENSE_SLOT_POST_INARTICLE_1 as string) || "",
  },
  adsenseInFeedLayoutKey:
    (env.VITE_ADSENSE_INFEED_LAYOUT_KEY as string) || "",
  gaMeasurementId: (env.VITE_GA_MEASUREMENT_ID as string) || "",
  gaMeasurementId2: (env.VITE_GA_MEASUREMENT_ID_2 as string) || "",
  gaMeasurementId3: (env.VITE_GA_MEASUREMENT_ID_3 as string) || "",

  gscVerification: (env.VITE_GSC_VERIFICATION as string) || "",
  nav: [
    { label: "Home", to: "/" },
    { label: "About", to: "/about-us" },
    { label: "Contact", to: "/contact-us" },
    { label: "Privacy Policy", to: "/privacy-policy" },
    { label: "Terms & Conditions", to: "/terms-condition" },
  ] as NavItem[],
  categories: [
    "CRM Reviews",
    "CRM Comparisons",
    "Buyer's Guides",
    "Sales Automation",
    "Small Business CRM",
  ] as string[],
};

export function categorySlug(c: string): string {
  return c
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}
